<template>
  <div class="banner-big-box">
    <div class="banner-box">
      <el-container>
        <el-aside width="178px">
            <!-- :default-active="activeIndex" -->
            <!-- router -->
          <el-menu class="nav-box"
            @select="handleSelect"
            background-color="#FF2742"
            text-color="#fff"
            active-text-color="#fff">
            <el-submenu index="1" class="nav-name-box">
              <template slot="title"><i class="el-icon-menu"></i><span>所有分类</span></template>
              <el-menu-item :index="item1.Id.toString()" class="nav-name" v-for="(item1, index1) in navData" :key="index1">
                <template slot="title"><i class="el-icon-menu"></i><span>{{item1.NaviName}}</span></template>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </el-aside>
        <el-container>
          <el-header style="text-align:left;">
            <el-tabs style="width:900px;display:inline-block;" class="tabs-box" v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="首页" name="0"></el-tab-pane>
              <el-tab-pane v-for="(item, index) in tabsData" :key="index" :label="item.NaviName" :name="item.Id.toString()"></el-tab-pane>
              <el-tab-pane label="方案下载" name="-1"></el-tab-pane>
            </el-tabs>
            <div class="ruzhu">
              <span @click="shopSettled">店铺入驻</span>
            </div>
          </el-header>
          <!-- <el-aside> -->
          <!-- </el-aside> -->
        </el-container>
      </el-container>
    </div>
  </div>
</template>
<script>
import {
  ProductNaviList
} from '../../api/api'
export default {
  name: 'AXbanner',
  data(){
    return{
      activeName: '0',
      tabsData: [
      //   {
      //   Id: 0,
      //   NaviName: '首页'
      // }
      ],
      navData: []
    }
  },
  watch:{
    'this.$route.path'(newv, oldV){
      console.log(newv, oldV)
      // switch(this.$route.path){
      //   case '/home': 
      //     this.activeName = '1';
      //     break;
      //   case '/home/airCondition': 
      //     this.activeName = '2';
      //     break;
      // }
    }
  },
  created(){
    this.watchPath()
    this.getNav()
    
  },
  methods: {
    shopSettled(){
      this.$router.push('/register')
    },
    getNav(){
      ProductNaviList().then(res => {
        if(res.data.success){
          this.navData = res.data.response || []
          this.tabsData = res.data.response || []
          // console.log(res.data.response,this.navData,this.tabsData,'wwwwwwww')
        } else{
          this.$message.error(res.data.msg)
        }
      })
    },
    watchPath(){
      switch(this.$route.path){
        case '/home/industryReport': 
          this.activeName = '-1';
          break;
        case '/home': 
          this.activeName = '0';
          break;
        case '/home/airCondition':
          this.activeName = '1';
          break;
        case '/home/refrigerator':
          this.activeName = '2';
          break;
        case '/home/television':
          this.activeName = '3';
          break;
        case '/home/washingMachine':
          this.activeName = '4';
          break;
        case '/home/kitchenAppliances':
          this.activeName = '5';
          break;
        case '/home/lifeAppliances':
          this.activeName = '6';
          break;
        case '/home/digitals':
          this.activeName = '10';
          break;
      }
    },
    handleClick(){
      switch(this.activeName){
        case '-1': 
          this.$router.push('/home/industryReport');
          break;
        case '0': 
          this.$router.push('/home');
          break;
        case '1':
          this.$router.push('/home/airCondition');
          break;
        case '2': 
          this.$router.push('/home/refrigerator');
          break;
        case '3':
          this.$router.push('/home/television');
          break;
        case '4': 
          this.$router.push('/home/washingMachine');
          break;
        case '5':
          this.$router.push('/home/kitchenAppliances');
          break;
        case '6': 
          this.$router.push('/home/lifeAppliances');
          break;
        case '10':
          this.$router.push('/home/digitals');
          break;
      }
    },
    handleSelect(val){
      this.activeName = val
      switch(val){
        case '0': 
          this.$router.push('/home');
          break;
        case '1':
          this.$router.push('/home/airCondition');
          break;
        case '2': 
          this.$router.push('/home/refrigerator');
          break;
        case '3':
          this.$router.push('/home/television');
          break;
        case '4': 
          this.$router.push('/home/washingMachine');
          break;
        case '5':
          this.$router.push('/home/kitchenAppliances');
          break;
        case '6': 
          this.$router.push('/home/lifeAppliances');
          break;
        case '10':
          this.$router.push('/home/digitals');
          break;
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.banner-big-box{
  // background-color: #CB0910;
  // background-size: 50% 100%;
  margin-bottom: -20px;
  position: relative;
}
.banner-box{
  width: 1200px;
  // height: 551px;
  margin: 0 auto;
  .nav-box{
    width: 177px;
    overflow: hidden;
    position: absolute;
    z-index: 100;
  }
  .nav-name-box{
    text-align: left;
  }
  .nav-name{
    text-align: left;
    height: 50px;
  }
  .tabs-box /deep/ .el-tabs__active-bar{
    background-color: #CB0910;
  }
  .tabs-box /deep/ .is-active{
    color: #CB0910;
  }
  .tabs-box /deep/ .el-submenu /deep/ .el-submenu__title{
    height: 40px;
    line-height: 40px;
  }
  .ruzhu{
    height: 40px;
    line-height: 40px;
    float: right;
    color: #f40000;
    font-weight: bold;
    cursor: pointer;
  }
}
.el-main{
  line-height: 60px;
}
</style>